import { render, staticRenderFns } from "./teamIncoming.vue?vue&type=template&id=79a50c06&scoped=true&"
import script from "./teamIncoming.vue?vue&type=script&lang=js&"
export * from "./teamIncoming.vue?vue&type=script&lang=js&"
import style0 from "./teamIncoming.vue?vue&type=style&index=0&id=79a50c06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a50c06",
  null
  
)

export default component.exports